/* global axios */
import ApiClient from './ApiClient';

/**
 * EngageAccessor API Client
 *
 * Handles communication with the Engage Accessor AI Assistant service.
 * Backend configuration is managed via environment variables:
 * - ENGAGE_ACCESSOR_API_KEY: API key for authentication
 * - ENGAGE_ACCESSOR_API_URL: API endpoint URL
 * - ENGAGE_ACCESSOR_MODEL: AI model to use
 * - ENGAGE_ACCESSOR_TIMEOUT: Request timeout in seconds
 */
class EngageAccessorApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  processMessage(conversationId, data) {
    // data should contain { messages: [...], context: {...}, clear_context: boolean, images: [...] }
    return axios.post(
      `${this.url}/${conversationId}/engage_accessor/process_message`,
      data
    );
  }

  getConversationContext(conversationId) {
    return axios.get(`${this.url}/${conversationId}/engage_accessor/context`);
  }

  // MIT-clean conversation summary via the Engage Accessor LLM.
  summarize(conversationId, { signal } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/engage_accessor/summarize`,
      {},
      { signal }
    );
  }

  // AI reply suggestion via the Engage Accessor LLM.
  suggestReply(conversationId, { signal } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/engage_accessor/suggest_reply`,
      {},
      { signal }
    );
  }

  // Translate content to the given target language via the Engage Accessor LLM.
  translate(conversationId, { target_language, content }, { signal } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/engage_accessor/translate`,
      { target_language, content },
      { signal }
    );
  }
}

export default new EngageAccessorApi();
